import e from "../../utils/classNames.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/sidebars/SidebarFooter.tsx
var n = ({ footer: n, className: r = "" }) => {
	if (!n) return null;
	let i = e("SidebarFooter", r);
	return /* @__PURE__ */ t("div", {
		className: i,
		children: n
	});
};
//#endregion
export { n as default };

//# sourceMappingURL=SidebarFooter.js.map